<template>
    <v-container fluid>
        <v-row no-gutters>
            <v-col cols="12">
                <v-form ref="transactionAccountForm" @submit.prevent="saveTransactionAccount" class="custom-form">
                    <v-card :elevation="1" color="blue lighten-5">
                        <v-row no-gutters>
                            <v-col cols="12">
                                <v-toolbar color="#546E7A" dark :elevation="1" height="30px">
                                    <v-toolbar-title class="subtitle-2">Transaction Account Information</v-toolbar-title>
                                </v-toolbar>
                                <v-card-text class="py-0 mt-1">
                                    <v-row dense justify="center">
                                        <v-col cols="4">
                                            <v-row no-gutters class="mb-1">
                                                <v-col cols="3">Acct. ID</v-col>
                                                <v-col cols="9">
                                                    <v-text-field
                                                        dense
                                                        outlined
                                                        hide-details
                                                        readonly
                                                        :value="$store.getters['transactionAccount/newCode']"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row no-gutters class="mb-1">
                                                <v-col cols="3">Acct. Name</v-col>
                                                <v-col cols="9">
                                                    <v-text-field
                                                        dense
                                                        outlined
                                                        hide-details
                                                        :rules="[v => !!v]"
                                                        v-model="account.account_name"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-row no-gutters class="mb-1">
                                                <v-col cols="3" class="text-right pr-2">Description</v-col>
                                                <v-col cols="9">
                                                    <v-textarea
                                                        dense
                                                        outlined
                                                        hide-details
                                                        height="8vh"
                                                        v-model="account.description"
                                                    ></v-textarea>
                                                </v-col>
                                            </v-row>
                                            <v-row no-gutters>
                                                <v-col cols="3"></v-col>
                                                <v-col cols="9">
                                                    <v-row no-gutters>
                                                         <v-col cols="6" class="pr-1">
                                                            <v-btn @click="resetForm" height="30px" dark block color="deep-orange">Clear</v-btn>
                                                        </v-col>
                                                        <v-col cols="6">
                                                            <v-btn type="submit" :loading="waitingForSave" height="30px" dark block color="light-blue darken-2">Save</v-btn>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-form>
            </v-col>
        </v-row>
        <v-row dense class="mt-1">
            <v-col cols="12" class="pb-0">
                <v-data-table
                    class="custom-data-table elevation-1"
                    dense
                    :headers="accountHeaders"
                    :loading="$store.getters['transactionAccount/loading']"
                    :items="$store.getters['transactionAccount/transactionAccounts']"
                    :search="searchTransactionAccount"
                >
                    <template v-slot:top>
                        <v-toolbar dense color="white" :elevation="1" height="30px">
                            <v-toolbar-title class="subtitle-2">Transaction Account List</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-form class="custom-form">
                                <v-text-field
                                    outlined
                                    dense
                                    hide-details
                                    placeholder="Search Transaction Accounts"
                                    append-icon="mdi-magnify"
                                    style="width:300px;"
                                    v-model="searchTransactionAccount"
                                >
                                </v-text-field>
                            </v-form>
                        </v-toolbar>
                    </template>
                    <template v-slot:[`item.action`]="{ item }">
						<v-tooltip bottom>
							<template v-slot:activator="{ on }">
								<v-icon small @click="editTransactionAccount(item)" color="primary" v-on="on">mdi-circle-edit-outline</v-icon>
							</template>
							<span>Edit</span>
						</v-tooltip>
						<v-tooltip bottom>
							<template v-slot:activator="{ on }">
								<v-icon small @click="openDeleteDialog(item.id)" color="error" v-on="on" >mdi-delete-circle-outline</v-icon>
							</template>
							<span>Delete</span>
						</v-tooltip>
					</template>
                </v-data-table>
            </v-col>
        </v-row>

        <delete-confirm ref="deleteDialog" @confirm="deleteTransactionAccount"></delete-confirm>

    </v-container>
</template>

<script>
import DeleteConfirm from '@/components/Confirm'

export default {
    name: 'CashTransaction',
    components: {
        DeleteConfirm,
    },
    data: ()=> ({
        searchTransactionAccount: '',
        date: new Date().toISOString().substr(0, 10),
        accountHeaders: [
            { text: 'Account ID', value: 'code' },
            { text: 'Account Name', value: 'account_name' },
            { text: 'Description', value: 'description' },
            { text: 'Action', value: 'action' },
        ],

        account: {
            account_name: '',
            description: '',
        },

        waitingForSave: false,
        transactionAccountEditId: null,
        transactionAccountDeleteId: null,
    }),
    created() {
        this.$store.dispatch('transactionAccount/getTransactionAccounts')
        this.$store.dispatch('transactionAccount/getTrAccountCode')
    },
    methods: {
        async saveTransactionAccount() {
            if (!this.$refs.transactionAccountForm.validate()) return
            this.waitingForSave = true
            if (this.transactionAccountEditId == null) {
                let res = await this.$store.dispatch('transactionAccount/saveTransactionAccount', {
                    url: 'add-transaction-account',
                    data: this.account
                })
                if (res) this.resetForm()
            } else {
                let res = await this.$store.dispatch('transactionAccount/saveTransactionAccount', {
                    url: 'update-transaction-account',
                    data: {...this.account, id: this.transactionAccountEditId}
                })
                if (res) this.resetForm()
            }
            this.waitingForSave = false
        },

        editTransactionAccount(item) {
            this.transactionAccountEditId = item.id
            Object.keys(this.account).map(k => this.account[k] = item[k])
        },

        openDeleteDialog(id) {
            this.transactionAccountDeleteId = id
            this.$refs.deleteDialog.dialog = true
        },

        deleteTransactionAccount() {
            this.$store.dispatch('transactionAccount/deleteTransactionAccount', {id: this.transactionAccountDeleteId})
            this.$refs.deleteDialog.dialog = false
            this.transactionAccountDeleteId = null
        },

        resetForm() {
            Object.keys(this.account).map(k => this.account[k] = '')
            this.transactionAccountEditId = null
            this.$refs.transactionAccountForm.resetValidation()
        }
    }
}
</script>

<style lang="scss" scoped>
    .v-icon.v-icon {
       font-size: 18px !important;
       top: 0 !important;
    }
    .v-icon.v-icon[data-v-1f38b4e5] {
        font-size: 14px !important;
        top: 0px !important; 
    }
    .v-messages {
        flex: 1 1 auto;
        font-size: 12px;
        min-height: 0px !important;
        max-height: 0px!important;
        min-width: 1px;
        position: relative;
    }
</style>